import {Breadcrumb} from "antd";
import {useEffect, useState} from "react";
import './H3LayerTitle.css'

export function H3LayerTitle({id}) {
    const [breadcrumbData, setBreadcrumbData] = useState([{'title': '...'}]);

    useEffect(() => {

        const data = [
            {"title": "Exposure"},
            {"type": "separator"},
            {"title": "Risk analyzer"},
            // {"type": "separator"},
            // {"title": "Susceptibility 2010"}
        ]

        setBreadcrumbData(data)

    }, [id]);

    return (
        <div className="mapTitle">
            <div className="mapTitleBox">
                <Breadcrumb
                    separator=""
                    items={breadcrumbData}
                />
            </div>
        </div>
    )
}